<template>
    <div class="registro">
      <RegistroPage/>
    </div>
  </template>

<script>
import RegistroPage from '@/components/RegistroPage.vue'

export default {
  name: 'RegistroView', 
  components: {
    RegistroPage,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
